import React, {useContext}from 'react'
import { createContext } from 'react';
import { useState } from 'react';

const DocContext = createContext();

export const useDocAct = () => {
  const context = useContext(DocContext);
  return context;
};

export const DocProvider = ({ children }) =>{
  
  const [numAct, setUser] = useState({
    idActual: 0
  });

  const updateIdSesion = (newIdSesion) => {
   
    setUser((currentIdSesion) => ({
      ...currentIdSesion,
      idActual: newIdSesion
    }));
  };

  return (
    <DocContext.Provider value={{ numAct, updateIdSesion }}>
      {children}
    </DocContext.Provider>
  );
}